import axios from 'axios';

export const workflowErrorApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-error`,
    headers: {
        'Content-Type': 'application/json'
    }
})